import { Injectable } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { CommonUtil } from '../util/common-util';

export interface AttendanceResponse<T> { data: T; }

/** Authentication and transport shared by both document entry points and attendance. */
@Injectable({providedIn: 'root'})
export class AttendanceApiService {
  constructor(private auth: AuthService, private commonUtil: CommonUtil) {}

  async request<T>(eventId: number, path: string, body: object = {}, method: 'post'|'put' = 'post'): Promise<AttendanceResponse<T>> {
    const session = await Auth.currentSession();
    const options = {...this.auth.createApiHeader(session), body: {...body, id: eventId}};
    return method === 'put' ? this.commonUtil.apiPut(path, options) : this.commonUtil.apiPost(path, options);
  }

  async canManage(eventId: number): Promise<boolean> {
    if (!Number.isSafeInteger(eventId) || eventId < 1) return false;
    try {
      const result = await this.request<{canManage: boolean}>(eventId, '/myevent/attendance/capability');
      return result?.data?.canManage === true;
    } catch { return false; }
  }
}
